// Informational notes in the diagnostics report cap their text width rather than filling
// the card: long single lines read badly. The box itself stays full width — only the text
// wraps early. Shared so every note in the report wraps alike.
//
// Lucas (PRE-3158) specified a 540–600px range; 560 sits inside it. No exact AntD token
// for this.
export const REPORT_NOTE_MAX_TEXT_WIDTH = 560;
